export enum StoreEditorPage {
  BASIC_INFO,
  ORDERING_OPTIONS,
  PAYMENT_CONFIGURATION,
  POS_CONFIGURATION,
}
